import {URL} from '@netx/core-next/url';

export const getAssetPreviewUrlFromId = (id: number) =>
	`${URL.asset}/${id}/preview`;
